import { DataTable } from '@repo/ui';
import { StudentsWorkloadAchievementGroup } from 'domain/models';
import { useLegends } from 'presentation/app/hooks/useLegends';
import { makeStudentsWorkloadAchievementColumns } from 'presentation/app/modules/Reports/common/columns/students/students-workload-achievement-columns';
import { useMemo } from 'react';

interface IProps {
  group: StudentsWorkloadAchievementGroup;
}

export const WorkloadAchievementTable = ({ group }: IProps) => {
  const { getLegends } = useLegends();

  const rows = useMemo(
    () =>
      (group.rows || []).map((row) => ({
        ...row,
        id: row.studentHashId,
      })),
    [group],
  );

  const columns = useMemo(
    () => makeStudentsWorkloadAchievementColumns(getLegends('ESTUDANTE')),
    [getLegends],
  );

  return (
    <DataTable
      pagination
      data={rows}
      actions={[]}
      keyField="id"
      columns={columns}
      loading={false}
      canSearch={false}
      noDataVariant="filter"
      noDataTitle="Nenhum registro encontrado"
      noDataDescription="Não há dados de carga horária para este grupo."
    />
  );
};
